import React from 'react';
import { css } from '@emotion/core';
import Slick from 'react-slick';

import { below, breakpoints } from 'utils/breakpoint';
import getCarouselProps from 'editor/game_checkIn/components/lotteryTaskCarousel/getCarouselProps';

import useMediaQuery from '@material-ui/core/useMediaQuery';

import LotteryTaskCard from 'editor/game_checkIn/components/lotteryTaskCarousel/LotteryTaskCard';
export default function LotteryTaskCarousel({
    gameType,
    deskTopSlidesToShow = 3,
    disabledEdit,
    componentStyle = {},
    items = [],
    forwardCarouselRef = () => {},
    onTitleChange = () => {},
    onImgDrop = () => {},
    onImgDropError = () => {},
    onLazyLoaded = () => {},
    onGetWinner = () => {}
}) {
    const isXsmScreen = useMediaQuery(`(max-width:${breakpoints.xsm}px)`);
    const carouselProps = getCarouselProps({ deskTopSlidesToShow });
    const styleObj = {
        backgroundColor: componentStyle.lotteryTaskBgColor,
        color: componentStyle.lotteryTaskTextColor,
        borderRadius: componentStyle.contentBorderRadius
    };
    const itemsLength = items.length;
    const noNeedCarousel = isXsmScreen ? itemsLength === 1 : itemsLength <= deskTopSlidesToShow;

    if (itemsLength === 0) {
        return null;
    }

    const cards = items.map(item => {
        const {
            uuid,
            type,
            title,
            imgSrc,
            taskCondition,
            status,
            prizeLeftQuantity,
            prizeTotalQuantity,
            isIniting,
            isLazyLoading,
            isMgmSelf,
            isMgmShare
        } = item;
        return (
            <div css={cardWrapperStyle} key={uuid}>
                <LotteryTaskCard
                    gameType={gameType}
                    isIniting={isIniting}
                    isLazyLoading={isLazyLoading}
                    isEditorMode={!disabledEdit}
                    type={type}
                    title={title}
                    imgSrc={imgSrc}
                    checkInTargetQuantity={taskCondition}
                    prizeLeftQuantity={prizeLeftQuantity}
                    prizeTotalQuantity={prizeTotalQuantity}
                    status={status}
                    componentStyle={styleObj}
                    onLazyLoaded={() => onLazyLoaded(uuid, Boolean(isMgmSelf || isMgmShare))}
                    onTitleChange={v => onTitleChange(uuid, v)}
                    onImgDrop={resp => onImgDrop(uuid, resp)}
                    onImgDropError={errMsg => onImgDropError(errMsg)}
                    onButtonClick={() => onGetWinner(item)}
                    isMgmSelf={isMgmSelf}
                />
            </div>
        );
    });
    return noNeedCarousel ? (
        <div
            className="fever-lottery-task-cards"
            css={[containerStyle, cardFlexStyle(deskTopSlidesToShow)]}
        >
            {cards}
        </div>
    ) : (
        <div className="fever-lottery-task-cards" css={carouselContainerStyle}>
            <Slick {...carouselProps} ref={forwardCarouselRef}>
                {cards}
            </Slick>
        </div>
    );
}

const containerStyle = css`
    display: flex;
    justify-content: center;
    padding-top: 16px;
    transform: translate(0, 0);
`;

const cardFlexStyle = itemsPerRow => css`
    > * {
        width: ${Math.ceil(100 / itemsPerRow)}%;
    }
    ${below('sm')} {
        > * {
            width: 100%;
            padding-left: 24px;
            padding-right: 24px;
        }
    }
`;

const carouselContainerStyle = css`
    padding: 16px 24px 0;
    overflow: hidden;
    & .slick-arrow {
        &.slick-disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
        color: #000;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
    }
    & .slick-prev {
        left: -18px;
    }
    & .slick-next {
        right: -18px;
    }
    ${below('sm')} {
        padding: 16px 0px 0;
        & .slick-arrow.slick-prev,
        & .slick-arrow.slick-next {
            opacity: 0;
            pointer-events: none;
        }
    }
`;

const cardWrapperStyle = css`
    padding: 8px;
    ${below('sm')} {
        padding: 4px;
    }
`;
